import { render, staticRenderFns } from "./lowerStoreManage.vue?vue&type=template&id=a22e053a&scoped=true&"
import script from "./lowerStoreManage.vue?vue&type=script&lang=js&"
export * from "./lowerStoreManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22e053a",
  null
  
)

export default component.exports